var React = require('react');

function AnnualElectricity (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.9375 23.6143L18.405 12.7167H14.625V5.69432L9 16.5919H12.9375V23.6143ZM13.5 3.45432C16.5938 3.45432 19.2375 4.57432 21.4312 6.75832C23.625 8.94232 24.75 11.5743 24.75 14.6543C24.75 17.7343 23.625 20.3663 21.4312 22.5503C19.2375 24.7343 16.5938 25.8543 13.5 25.8543C10.4062 25.8543 7.7625 24.7343 5.56875 22.5503C3.375 20.3663 2.25 17.7343 2.25 14.6543C2.25 11.5743 3.375 8.94232 5.56875 6.75832C7.7625 4.57432 10.4062 3.45432 13.5 3.45432Z","fill":"#FECD12"}));
}

AnnualElectricity.defaultProps = {"width":"27","height":"29","viewBox":"0 0 27 29","fill":"none"};

module.exports = AnnualElectricity;

AnnualElectricity.default = AnnualElectricity;
